function getScriptHost() {
    var _a;
    const host = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host;
    if (/(localhost|127\.0\.0\.1):9000/.test(host)) {
        // Local development of the SDK
        return 'http://localhost:8585';
    }
    if (/pulse-react-demo\.stage\.picsart\.tools/.test(host) ||
        /dev-portal\.picsart\.tools/.test(host) ||
        /localhost:3000/.test(host)) {
        // Development
        return 'https://dev.optifyr.com';
    }
    if (/([^.]+\.)*picsartstage2\.com/.test(host) ||
        /([^.]+\.)+sdk\.picsart\.io/.test(host) ||
        /([^.]+\.)+admaker\.pages\.dev(:\d+)?/.test(host) ||
        /^https?:\/\/tools-preprod\.picsart\.com(:\d+)?/i.test(host) ||
        /localhost/.test(host) ||
        /127\.0\.0\.1/.test(host)) {
        // Staging
        return 'https://stage.optifyr.com';
    }
    // Production
    return 'https://optifyr.com';
}
function loadBrowserSdks(sdks, appState) {
    const win = window;
    win.dynamic = win.dynamic || {};
    const scriptModule = document.createElement('script');
    const scriptNomodule = document.createElement('script');
    const defaultHost = getScriptHost();
    const include = sdks.sort().join(',');
    scriptModule.type = 'text/javascript';
    scriptModule.async = true;
    scriptModule.fetchPriority = 'high';
    scriptNomodule.type = 'text/javascript';
    scriptNomodule.async = true;
    scriptNomodule.fetchPriority = 'high';
    scriptModule.type = 'module';
    scriptModule.src = `${defaultHost}/pulse/${appState.app}/module/pulse.js?include=${include}&version=${appState.app_version}&cid=${appState.cid}`;
    scriptNomodule.noModule = true;
    scriptNomodule.src = `${defaultHost}/pulse/${appState.app}/nomodule/pulse.js?include=${include}&version=${appState.app_version}&cid=${appState.cid}`;
    return new Promise((resolve, reject) => {
        scriptModule.onload = resolve;
        scriptModule.onerror = reject;
        scriptNomodule.onload = resolve;
        scriptNomodule.onerror = reject;
        document.head.appendChild(scriptModule);
        document.head.appendChild(scriptNomodule);
    });
}
export { loadBrowserSdks };
//# sourceMappingURL=core-loader.js.map